import { render } from "./CourseLessonSubpage.vue?vue&type=template&id=43539136&scoped=true"
import script from "./CourseLessonSubpage.vue?vue&type=script&lang=js"
export * from "./CourseLessonSubpage.vue?vue&type=script&lang=js"

import "./CourseLessonSubpage.vue?vue&type=style&index=0&id=43539136&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43539136"]])

export default __exports__